import { useMemo } from 'react';
import { useColorMode } from '@chakra-ui/react';
import { useAppSettings } from '../contexts/AppSettingsContext';
import { buildChartOptions } from '../theme/chart-config';

/**
 * Returns ApexCharts base options pre-configured with the current
 * theme preset colors, color mode, and accessible pattern preference.
 *
 * Spread or merge with chart-specific overrides in your component:
 *   const base = useChartOptions();
 *   const options = { ...base, xaxis: { ... } };
 */
export function useChartOptions(): ApexCharts.ApexOptions {
	const { themePreset } = useAppSettings();
	const { colorMode } = useColorMode();

	return useMemo(() => {
		return buildChartOptions({
			presetId: themePreset,
			colorMode: colorMode as 'light' | 'dark',
		});
	}, [themePreset, colorMode]);
}
